import React from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './styles.css';

const formatKey = (key) => {
  return key
    .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()) // Remove "_" & capitalize next letter
    .replace(/([A-Z])/g, ' $1') // Insert space before uppercase letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
    .replace(/_id$/, ' ID'); // Change "_id" suffix to " Id"
};

const isValidDate = (value) => {
  const date = new Date(value);
  return !isNaN(date.getTime()); // Checks if it's a valid date
};

const VerticalPrimeTable = ({ data, columns = [], actions = [] }) => {
  if (!data) return null;

  // const transformedData = [
  // 	...Object.entries(data)
  // 		.filter(
  // 			([key]) =>
  // 				key !== "deletedAt" && key !== "categoryId" && key !== "blocked"
  // 		)
  // 		.map(([key, value]) => {
  // 			// console.log("key, value", key, value);

  // 			if (typeof value === "object" && value !== null && !React.isValidElement(value)) {
  // 				value = value.name || value.username || JSON.stringify(value);
  // 			} else if (typeof value === "string" && isValidDate(value)) {
  // 				value = new Date(value).toLocaleString(); // Format date
  // 			}
  // 			return { field: formatKey(key), value };
  // 		}),
  // 	...actions.map(({ label, element }) => ({
  // 		field: label,
  // 		value: element,
  // 	})),
  // ];

  // Transform object data into an array of key-value pairs if necessary
  const tableData = Array.isArray(data)
    ? data
    : Object.entries(data).map(([key, value]) => {
        if (value === 'true' || value === '1') value = 'Yes';
        else if (value === 'false' || value === '0') value = 'No';
        return {
          Field: formatKey(key),
          Value: value ?? 'N/A', // Handle null or undefined values
        };
      });

  // Generate dynamic columns if none are provided
  const dynamicColumns =
    columns.length > 0
      ? columns
      : Object.keys(tableData[0] || {}).map((key) => ({
          field: key,
          header: formatKey(key),
        }));
  console.log('dynamicColumns', dynamicColumns);

  return (
    <DataTable
      value={tableData}
      // className="details-table"
      className="details-table-logs"
    >
      {/* Dynamically render columns */}
      {dynamicColumns.map((col, index) => (
        <Column
          key={index}
          field={col.field}
          header={col.header}
          className={
            col.field === 'Old_Value'
              ? 'old-value-column'
              : col.field === 'New_Value'
                ? 'new-value-column'
                : ''
          }
        />
      ))}
    </DataTable>
  );
};
/*

*/

export default VerticalPrimeTable;
